import { unwrapNonNull, unwrapNonNullTypeName } from "../util"


function checkNull(unwrapped, type, value)
{
    if (value === "")
    {
        if (unwrapped !== type)
        {
            return [null, "Value required"]
        }
        else
        {
            return [null, null]
        }
    }

    return false
}


export function resolveValidatorByType(t)
{
    const unwrapped = unwrapNonNull(t)
    switch (unwrapped.name)
    {
        case "Boolean":
            return (typeCtx, fd, value) => {
                return [value, null]
            }
        case "Int":
            return (typeCtx, fd, value) => {

                const result = checkNull(t, value);
                if (result)
                {
                    return result
                }

                const converted = +value
                if (isNaN(converted))
                {
                    return [null, "Invalid number"]
                }
                return [converted, null]
            }
        default:
            // default // "String"
            return (typeCtx, fd, value) => {
                const result = checkNull(t, value);
                if (result)
                {
                    return result
                }
                return [value, null]
            }
    }
}
